export default __webpack_public_path__ + "static/media/gallery-wip-denix-scope-mount-hole_05.228a4f02.jpg";